import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';
import { Component, OnInit, ViewChild, ViewContainerRef, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { HisComponentRegistryService } from '../../service/his-component-registry.service';
import { HisUiService } from '../../../core/service/base/his-ui.service';

@Component( {
    template: '<ng-template #newOldContainerRef></ng-template>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class OldNewFieldContainerComponent implements OnInit {
    private hisComponentRegistryService = inject(HisComponentRegistryService);
    private hisUiService = inject(HisUiService);
    hisBaseGlobalsService = inject(HisBaseGlobalsService);

    @ViewChild('newOldContainerRef', { static: true, read: ViewContainerRef }) vcr!: ViewContainerRef;
    injectedDataOld: HisDynamicFieldConfigAndData;
    injectedDataNew: HisDynamicFieldConfigAndData;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);

        this.injectedDataOld = {...injectedData, options: {...injectedData.options}};
        this.injectedDataOld.options.label = this.getlabel(this.injectedDataOld, true);
        this.injectedDataOld.options.disabled = true;
        this.injectedDataOld.options.name += 'Old';
        this.injectedDataOld.options.defaultValue = this.injectedDataOld.options.oldValue;

        this.injectedDataNew = {...injectedData, options: {...injectedData.options}};
        this.injectedDataNew.options.label = this.getlabel(this.injectedDataNew, false);
    }

    ngOnInit() {
        let comp = this.hisComponentRegistryService.getComponentClass( this.injectedDataOld.options.controlType );
        const myInjectorOld = this.createInjectorOld();
        const myInjectorNew = this.createInjectorNew();
        this.vcr.createComponent(comp, {index: 0, injector: myInjectorNew });
        this.vcr.createComponent(comp, {index: 1, injector: myInjectorOld });

    }

    getlabel(data: HisDynamicFieldConfigAndData, oldVal: boolean) {
        let translatedLabeltextIdentifier = this.hisUiService.translate( this.getLabeltextIdentifier( data.options.ddKey ) );
        const label = data.options.label ? this.hisUiService.translate( data.options.label ) :
            translatedLabeltextIdentifier ? translatedLabeltextIdentifier : this.hisUiService.translate( data.options.ddKey );
        const oldLabel = this.hisUiService.translate('I18nValue.old');
        const newLabel = this.hisUiService.translate('I18nValue.new');
        return label + (oldVal ? ` (${oldLabel})` : ` (${newLabel})`);
    }

    createInjectorOld(): Injector {
        return Injector.create(
            {
                providers: [
                    {
                        provide: 'injectedData',
                        useValue: this.injectedDataOld
                    }
                ]
            }
        );
    }
    createInjectorNew(): Injector {
        return Injector.create(
            {
                providers: [
                    {
                        provide: 'injectedData',
                        useValue: this.injectedDataNew
                    }
                ]
            }
        );
    }

    public getLabeltextIdentifier( dDKey: string ) {
        return this.hisBaseGlobalsService.getDd( dDKey )?.labeltextIdentifier;
    }
}
